import React, { Fragment, useState, useRef, useEffect } from 'react';

import { Modal } from 'flowbite';

import { parseLocaleNumber } from 'Helpers/currencyFormat';
import { modalOptions } from 'Helpers/modalOptions';

import NumberFormat from 'CommonComponents/LocalisedNumberFormat';
import SimpleConfirmationModal from 'CommonComponents/SimpleConfirmationModal';

import PlusIcon from 'Assets/icons/plus.svg';
import TrashIcon from 'Assets/icons/trash.svg';

export default function InputsPrePost(props) {
    const [deletedRow, setDeletedRow] = useState({});
    const [inputPrePostDeleteRowModalElement, setInputPrePostDeleteRowModalElement] = useState(null);

    const inputPrePostDeleteRowModalRef = useRef();

    useEffect(() => {
        inputPrePostDeleteRowModalRef && setInputPrePostDeleteRowModalElement(new Modal(inputPrePostDeleteRowModalRef.current, modalOptions(false)));
    }, []);

    const changeOtherDescription = (e, category, index) => {
        const data = JSON.parse(JSON.stringify(props.data));
        let val = e.target.value;
        let row = data[category][index];
        row = _.mapKeys(row, (value, key) => val);
        data[category][index] = row;
        props.changeHandler(data);
    };

    const setDeleted = (category, index, entity) => {
        setDeletedRow({
            category,
            index,
            entity,
        });
        inputPrePostDeleteRowModalElement && inputPrePostDeleteRowModalElement.show();
    };

    const deleteRow = () => {
        if (Object.keys(deletedRow).length) {
            let data = JSON.parse(JSON.stringify(props.data));

            data[deletedRow.category] = data[deletedRow.category].filter((item, ind) => {
                return ind != deletedRow.index;
            });
            props.changeHandler(data);
        }

        inputPrePostDeleteRowModalElement && inputPrePostDeleteRowModalElement.hide();
        setDeletedRow({});
    };

    const closeHandler = () => {
        inputPrePostDeleteRowModalElement && inputPrePostDeleteRowModalElement.hide();
        setDeletedRow({});
    };

    const changeValue = (e, category, index, key, valueKey) => {
        const data = JSON.parse(JSON.stringify(props.data));
        let val = parseLocaleNumber(e.target.value);
        val = Number.isNaN(val) ? 0 : val;
        data[category][index][key][valueKey] = val;
        props.changeHandler(data);
    };

    const addLine = (e, category) => {
        e.preventDefault();
        const data = JSON.parse(JSON.stringify(props.data));
        data[category].push({ '': defaultData() });
        props.changeHandler(data);
    };

    const defaultData = () => {
        return {
            indirect_percent: 0,
            induced_percent: 0,
            value: 0,
        };
    };

    const groups = [{ pre: '1. Pre Event' }, { post: '2. Post Event' }];

    const subGroups = {
        pre: [],
        post: [],
    };

    const cellKeys = ['indirect_percent', 'induced_percent'];

    return (
        <div className="table__card">
            <h2 className="table__header tw-mb-6">Pre and Post Event</h2>
            <div className="inbud-table_wrapper">
                <table className="inbud-table">
                    <thead>
                        <tr>
                            <th className="tw-border-r-2" rowSpan={2} style={{ width: '25%' }}>
                                {$t('Description')}
                            </th>
                            <th className="!tw-pb-1.5 !tw-font-extrabold tw-border-r-2 tw-uppercase" colSpan={3}>
                                {$t('Inputs')}
                            </th>
                            <th className="!tw-pb-1.5 !tw-font-extrabold tw-uppercase" colSpan={2}>
                                {$t('Outputs')}
                            </th>
                        </tr>
                        <tr className="*:!tw-pt-1.5">
                            <th>{$t('Value')}</th>
                            <th>{$t('Indirect')}</th>
                            <th className="tw-border-r-2">{$t('Induced')}</th>
                            <th>{$t('Total Indirect')}</th>
                            <th>{$t('Total Induced')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {groups.map((group, index) => {
                            const groupKey = Object.keys(group)[0];
                            const groupTitle = Object.values(group)[0];

                            return (
                                <Fragment key={groupKey}>
                                    {subGroups[groupKey].length === 0 && (
                                        <>
                                            {[''].map((vv) => {
                                                const data = props.data[groupKey];

                                                let totalValue = 0;
                                                let indirectTotal = 0;
                                                let inducedTotal = 0;

                                                return (
                                                    <Fragment key={groupTitle}>
                                                        <tr>
                                                            <td className="tw-font-semibold" colSpan={100}>
                                                                <div className="tw-flex tw-items-center tw-gap-x-2">
                                                                    {$t(groupTitle)}
                                                                    <button className="table__icon-btn small" onClick={(e) => addLine(e, groupKey)}>
                                                                        <PlusIcon className="tw-w-2.5 tw-h-2.5" />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        {data.map((row, rowIndex) => {
                                                            const rowData = Object.values(row);
                                                            const rowName = Object.keys(row)[0];

                                                            const value = rowData[0].value || '0';
                                                            const indirectPercent = rowData[0].indirect_percent || '0';
                                                            const inducedPercent = rowData[0].induced_percent || '0';

                                                            const totalIndirect = (value * parseFloat(indirectPercent)) / 100;
                                                            const totalInduced = (value * parseFloat(inducedPercent)) / 100;

                                                            totalValue += parseFloat(value);
                                                            indirectTotal += totalIndirect;
                                                            inducedTotal += totalInduced;

                                                            return (
                                                                <tr className="!tw-bg-white" key={`${groupTitle}_${rowIndex}`}>
                                                                    <td>
                                                                        <div className="tw-flex tw-gap-x-2">
                                                                            <input
                                                                                className="text-input"
                                                                                type={'text'}
                                                                                value={rowName}
                                                                                placeholder={$t('Enter line description')}
                                                                                onChange={(e) => {
                                                                                    changeOtherDescription(e, groupKey, rowIndex);
                                                                                }}
                                                                            />
                                                                            {data.length > 1 && (
                                                                                <button className="tw-text-red" onClick={(e) => setDeleted(groupKey, rowIndex)}>
                                                                                    <TrashIcon className="tw-w-3 tw-h-3" />
                                                                                </button>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <NumberFormat
                                                                            thousandSeparator={true}
                                                                            inputMode="numeric"
                                                                            className="text-input"
                                                                            value={rowData[0].value}
                                                                            onChange={(e) => {
                                                                                changeValue(e, groupKey, rowIndex, rowName, 'value');
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    {cellKeys.map((cellKey) => {
                                                                        return (
                                                                            <td key={groupKey + '_' + cellKey}>
                                                                                <div className="tw-relative after:tw-content-['%'] after:tw-absolute after:tw-right-2 after:tw-top-1/2 after:-tw-translate-y-1/2">
                                                                                    <input
                                                                                        className="text-input"
                                                                                        type={'number'}
                                                                                        value={rowData[0][cellKey]}
                                                                                        min="0"
                                                                                        max="100"
                                                                                        onChange={(e) => {
                                                                                            changeValue(e, groupKey, rowIndex, rowName, cellKey);
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                        );
                                                                    })}
                                                                    <td>{props.format(totalIndirect)}</td>
                                                                    <td>{props.format(totalInduced)}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </Fragment>
                                                );
                                            })}
                                        </>
                                    )}
                                </Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <SimpleConfirmationModal
                closeHandler={closeHandler}
                successHandler={deleteRow}
                allowAction={Object.keys(deletedRow).length > 0}
                modalId={'inputs-pre-post-delete-row'}
                modalRef={inputPrePostDeleteRowModalRef}
                modalElement={inputPrePostDeleteRowModalElement}
                confirmationMsg={'Are you sure you want to delete this ' + deletedRow?.entity + '?'}
                title={'Delete ' + deletedRow?.entity}
                cancelButtonText={$t('Cancel')}
                primaryButtonText={$t('OK')}
            />
        </div>
    );
}
